import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

export const fetchEspDiagnosisData = createAsyncThunk(
  'wellCompletions/fetchEspDiagnosisData',
  async ({ testId, wellId }: { testId?: number; wellId: number }) => {
    try {
      let url = `/pumpchecker/Test/ESPDiagnosisData?WellId=${wellId}`;
      if (testId !== undefined && testId !== null) {
        url = `/pumpchecker/Test/ESPDiagnosisData?TestId=${testId}&WellId=${wellId}`;
      }
      const requestPayload = createWrapperPayload('GET', url);

      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching esp diagnosis data:', error);
      return {};
    }
  },
);
